import type { SpeedDialDesignTokens } from '@primeuix/themes/types/speeddial';

 export default {
    root: {
        gap: "0.5rem",
        transitionDuration: "{transition.duration}"
    }
} satisfies SpeedDialDesignTokens;